import React from 'react';
import ProductManager from '../components/Dashboard/ProductManager';

export default function PanelPage(){
  return (
    <main className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-4">Panel del cliente</h1>
      <ProductManager />
    </main>
  );
}